import { render, staticRenderFns } from "./system-inform.vue?vue&type=template&id=08335676&scoped=true"
import script from "./system-inform.vue?vue&type=script&lang=js"
export * from "./system-inform.vue?vue&type=script&lang=js"
import style0 from "./system-inform.vue?vue&type=style&index=0&id=08335676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08335676",
  null
  
)

export default component.exports